import { render } from "./OneTimePassword.vue?vue&type=template&id=04aa5f5f&scoped=true"
import script from "./OneTimePassword.vue?vue&type=script&lang=js"
export * from "./OneTimePassword.vue?vue&type=script&lang=js"

import "./OneTimePassword.vue?vue&type=style&index=0&id=04aa5f5f&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa5f5f"]])

export default __exports__